var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isFaceB2B)?_c('AdministrativeCentersFB2B',{attrs:{"send-type":_vm.SendType,"loading":_vm.loading}}):_c('AdministrativeCenters',{attrs:{"send-type":_vm.SendType,"loading":_vm.loading}})}
var staticRenderFns = []

export { render, staticRenderFns }